import React from 'react';

import { IconButton, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '280px',
      },
    },
  };
});

export default ({ onSearchChange, onSearchClick, keyword }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <TextField
        fullWidth
        onChange={onSearchChange}
        onKeyUp={(evt) => {
          if (evt.key === 'Enter') {
            onSearchClick();
          }
        }}
        placeholder="Search"
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton onClick={onSearchClick}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        type="text"
        value={keyword}
      />
    </div>
  );
};
